import appointmentReducer from './appointmentSlice';
import * as appointmentActions from './actions';
import * as appointmentSelector from './selector';

export {
  appointmentActions,
  appointmentSelector
}

export default appointmentReducer